var amt_admin = require('amt_admin').default;
var app = require('angular').module('ww2_analytics.tutorial', [amt_admin]);

app.service('tutorial_api', ['jsonrpc', function (jsonrpc) {
    var service = jsonrpc.newService('tutorial');
    this.tutorial_by_days = service.createMethod('tutorial_by_days');
    this.discribe_main_steps = service.createMethod('discribe_main_steps');
    this.main_tutorial = service.createMethod('main_tutorial');
}]);

app.config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider
            .state('amt.ww2.tutorial', {
                    url: '/tutorial',
                    abstract: true,
                    template: '<div class="row" ui-view></div>',
                    data: {
                        priority: 801,
                        title: 'Tutorial',
                        role: 'tutorial'
                    },
                    menu: {
                        glyphicon: 'book',
                        childs: [
                            {
                              state: "amt.ww2.tutorial.main",
                              glyphicon: "book"
                            },
                            {
                              state: "amt.ww2.tutorial.main_total",
                              glyphicon: "book"
                            },
                            {
                              state: "amt.ww2.tutorial.tutorial_by_days",
                              glyphicon: "book"
                            },
                        ]
                    }
            })
            .state('amt.ww2.tutorial.main', require('./main').default)
            .state('amt.ww2.tutorial.main_total', require('./main_total').default)
            .state('amt.ww2.tutorial.tutorial_by_days', require('./by_days').default)
        ;
    }]);

export default app.name;
